export type HorizontalDirection = 'left' | 'right';
export type VerticalPosition = 'top' | 'bottom';
export type VerticalDirection = 'up' | 'down';
export type Direction = HorizontalDirection | VerticalDirection;
export type Position = HorizontalDirection | VerticalPosition;

export interface ITooltipDirectiveArg {
    position: Position;
    event?: 'focus';
}

export function getTooltipDirectiveArg (position: Position, useFocusEvent = false): ITooltipDirectiveArg {
    const arg: ITooltipDirectiveArg = { position };

    if (useFocusEvent) {
        arg.event = 'focus';
    }

    return arg;
}
